/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/dashboard",
    name: "Início",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    url: "/gravacoes",
    name: "Gravações",
    slug: "gravacoes",
    icon: "VideoIcon",
  },
  {
    url: "/contatos",
    name: "Contatos",
    slug: "contatos",
    icon: "UsersIcon",
  }
]
